// localStorage wrapper for the "last Zasso session" footer shown on the
// idle screen (spec U-ZAS symmetric to U-OKO-6).

const STORAGE_KEY = "koe.zasso.lastSession";

export interface ZassoLastSession {
  savedPath: string;
  durationSec: number;
  /** Number of assistant turns — rough "turns" count for the summary line. */
  turnCount: number;
  savedAt: number; // epoch ms
}

export function readLastSession(): ZassoLastSession | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ZassoLastSession>;
    if (
      typeof parsed.savedPath !== "string" ||
      typeof parsed.durationSec !== "number" ||
      typeof parsed.turnCount !== "number" ||
      typeof parsed.savedAt !== "number"
    ) {
      return null;
    }
    return parsed as ZassoLastSession;
  } catch {
    return null;
  }
}

export function writeLastSession(entry: ZassoLastSession): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
  } catch {
    /* ignore quota / private browsing */
  }
}
